/* eslint no-sequences: "off", wrap-iife: "off" */
define(['app'], function (app) {
  return app.Marionette.ItemView.extend({
    template: false,

    options: {
      tokens: '',
      nonce: ''
    },

    onRender: function () {
      if (this.getOption('tokens')) {
        var tokens = this.getOption('tokens')

        for (var i = 0; i < tokens.length; i++) {
          var name = tokens[i]['name'].replace('-', '_')
          var token = tokens[i]['token']

          this.renderCommands(name, token)
        }
      }
    },

    renderCommands: function (name, token) {
      if (token) {
        var setter = name + '.set'
        var sender = name + '.send'
        var cookieExpiration = 60 * 60 * 24 * 365

        window.ga('create', token, 'auto', name, { 'cookieExpires': cookieExpiration })
        window.ga(setter, 'forceSSL', true)
        // cookies expire after 1 years if user opts-in
        window.ga(setter, 'cookieExpires', this.options.privacyLevel > 1 ? cookieExpiration : 0)
        window.ga(setter, 'anonymizeIp', this.options.privacyLevel < 2)
        window.ga(setter, 'allowAdFeatures', this.options.privacyLevel > 2)

        window.ga(sender, 'pageview')
      }
    },

    initialize: function () {
      var nonce = this.options.nonce;
      (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r
        i[r] =
          i[r] ||
          function () {
            (i[r].q = i[r].q || []).push(arguments)
          }
        i[r].l = 1 * new Date()
        a = s.createElement(o)
        a.setAttribute('nonce', nonce)
        m = s.getElementsByTagName(o)[0]
        a.async = true
        a.src = g
        m.parentNode.insertBefore(a, m)
      })(
        window,
        document,
        'script',
        '//www.google-analytics.com/analytics.js',
        'ga'
      )
    }
  })
})
